import { useState } from "react";
import { Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface ExpandableCardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
  defaultExpanded?: boolean;
}

export function ExpandableCard({
  children,
  className,
  defaultExpanded = false
}: ExpandableCardProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <>
      <Card className={cn("relative", className)}>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-2 top-2 h-8 w-8"
            onClick={() => setIsExpanded(true)}
          >
            <Maximize2 className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>

      <Dialog open={isExpanded} onOpenChange={setIsExpanded}>
        <DialogContent className="max-w-6xl w-[90vw] h-[90vh] overflow-y-auto !duration-200 !transition-all">
          <DialogHeader className="flex flex-row items-center justify-between"></DialogHeader>
          {children}
        </DialogContent>
      </Dialog>
    </>
  );
}
